// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ccae4266","239":"b005a288","453":"2799bce5","455":"f90251b2"}[chunkId] + ".chunk.js";
};